import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforme un tableau de type de donnée en type de filtre
 */
@Pipe({
  name: 'crtHierarchyFilterValues',
  standalone: true,
})
export class CrtHierarchyFilterValuesPipe implements PipeTransform {
  transform(values: string[], nbValuesMax: number, fullText = 'Tous'): string {
    if (!values) {
      return '';
    }
    if (values.length <= 1) {
      return values.toString();
    }
    if (values.length === nbValuesMax) {
      return $localize`${fullText}`;
    }
    return values.join(', ');
  }
}
